import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { ListGroupItem, ListGroup } from 'react-bootstrap';
import Swipe from 'react-easy-swipe';

import Notification from 'components/notifications/Notification';

import 'style/containers/notifications/notification-alerts.scss';

const TIMEOUT_ALERT = 5000;
const INTERVAL_ALERT = 500;

/** Component to render an alert panel with all the alerts */
class NotificationAlerts extends Component {

    static propTypes = {
        alerts: PropTypes.array.isRequired, // Array with all the alerts to show
        onHide: PropTypes.func.isRequired // Listener when alert should hide
    };

    state = {
        hover: false
    };

    componentWillMount() {
        this.handleMouseOut = this.handleMouseOut.bind(this);
        this.handleDownload = this.handleDownload.bind(this);
    }

    /**
     * Hide the alert when swipping
     */
    handleSwipe(notification) {
        const {onHide} = this.props;

        return () => {
            onHide(notification);
        };
    }

    handleMouseOver() {
        return () => {
            this.setState({
                hover: true
            });
        };
    }

    handleMouseOut() {
        this.setState({
            hover: false
        });
    }

    manageHide(notification) {
        const {onHide} = this.props;
        const {hover} = this.state;

        if (hover) {
            if (!this.interval) {
                this.interval = setInterval(this.manageHide.bind(this, notification), INTERVAL_ALERT);
            }
        } else {
            clearInterval(this.interval);
            this.interval = undefined;
            onHide(notification);
        }
    }

    handleDownload(e, url) {

        window.location.href = url;

    }

    renderList() {
        const {alerts, onHide} = this.props;

        return alerts
            .map(notification => {
                setTimeout(this.manageHide.bind(this, notification), TIMEOUT_ALERT);

                return (
                    <Swipe
                        key={notification.id}
                        onSwipeLeft={this.handleSwipe(notification)}
                        onSwipeRight={this.handleSwipe(notification)}
                    >
                        <div onMouseOver={this.handleMouseOver(notification.id)} onMouseOut={this.handleMouseOut} >
                            <ListGroupItem>
                                <div className="notification-alerts-background" />
                                <Notification
                                    isAlert
                                    notification={notification}
                                    onRemove={onHide}
                                    component={notification.component}
                                    onDownload={this.handleDownload}
                                />
                            </ListGroupItem>
                        </div>
                    </Swipe>
                );
            });
    }

    render() {
        return (
            <div className="notification-alerts">
                <ListGroup>
                    {this.renderList()}
                </ListGroup>
            </div>
        );
    }
}

export default injectIntl(NotificationAlerts);



// WEBPACK FOOTER //
// ./src/components/notifications/NotificationAlerts.jsx